import React from "react";
import _ from "lodash";
import moment from "moment-timezone";
import { calculateReportsForDemandTypeCompare } from "./AnatomyCstReportHelper";
import HighchartWrapper from "components/common/HighchartWrapper";
import Highcharts from "highcharts";
import {
  PRESETS,
  getGoogleEligibleDemandTypes,
  getHolisticDemandTypes,
  getPrebidDemandTypes,
} from "constants/DemandType";

import { getDateTimeXAxis } from "helpers/Chart";
import { AnatomyCSTContext } from "./context/AnatomyCSTContext";

const PRESET_OPTIONS = [
  PRESETS.NETWORK_BILLABLE,
  PRESETS.GOOGLE_ELIGIBLE,
  PRESETS.PREBID,
  PRESETS.HOLISTIC,
];
const METRIC_OPTIONS = ["rrpm", "str", "ecpm"];
class DemandTypeCompareChart extends React.Component {
  static contextType = AnatomyCSTContext;

  constructor(props) {
    super(props);

    this.ref1 = React.createRef();

    const { groupType, layerNum, metric, groupTypes } = props;

    this.state = {
      // chart
      options: null,

      // filter options
      groupTypes,
      layerNums: ["all", "1", "2"], // [all, 1, 2] or [all]
      metrics: METRIC_OPTIONS,
      demandTypes: ["All", ...PRESET_OPTIONS],

      // filter
      groupType,
      layerNum,
      metric,
      demandType: "All",

      compareToGroupType: "b",
    };

    this.handleFilterChanged = this.handleFilterChanged.bind(this);
  }

  componentDidMount() {
    const { data, unitInfo, getFilterParams, timezoneType } = this.props;
    const { timezone } = this.context;

    const filterParams = getFilterParams();

    const { groupType, layerNum, metric } = this.props;
    const selectedFilter = {
      ...filterParams,

      groupType,
      layerNum,
      metric,
      // layerNum: "all", // all, 1, 2
      // metric: "rrpm", // rrpm, str, ecpm
      // groupType: "o", //
      compareToGroupType: "b",
      demandType: "All",
    };

    let tz = timezone;
    if (timezoneType === "TAIPEI") {
      tz = "Asia/Taipei";
    }

    const seriesData = _createSeriesData({
      data,
      unitInfo,
      filter: selectedFilter,
      timezone: tz,
    });
    const options = _createChartOptions({
      seriesData,
      timezone: tz,
      filter: selectedFilter,
    });

    this.setState({ options });
  }

  handleFilterChanged({ type, value }) {
    const { layerNum, metric, groupType, compareToGroupType, demandType } =
      this.state;
    const { timezone } = this.context;
    const { unitInfo, data, timezoneType } = this.props;
    const filterParams = this.props.getFilterParams();

    let tz = timezone;
    if (timezoneType === "TAIPEI") {
      tz = "Asia/Taipei";
    }

    const selectedFilter = {
      ...filterParams,
      layerNum: type === "layerNum" ? value : layerNum,
      metric: type === "metric" ? value : metric,
      groupType: type === "groupType" ? value : groupType,
      compareToGroupType:
        type === "compareToGroupType" ? value : compareToGroupType,
      demandType: type === "demandType" ? value : demandType,
    };
    const seriesData = _createSeriesData({
      data,
      unitInfo,
      timezone: tz,
      filter: selectedFilter,
    });
    const options = _createChartOptions({
      seriesData,
      timezone: tz,
      filter: selectedFilter,
    });

    this.setState({
      options,
      layerNum: type === "layerNum" ? value : layerNum,
      metric: type === "metric" ? value : metric,
      groupType: type === "groupType" ? value : groupType,
      compareToGroupType:
        type === "compareToGroupType" ? value : compareToGroupType,
      demandType: type === "demandType" ? value : demandType,
    });
  }

  render() {
    const {
      // chart
      options,

      // filter options
      groupTypes,
      layerNums,
      metrics,
      demandTypes,

      // selected filter
      groupType,
      layerNum,
      metric,
      demandType,
      compareToGroupType,
    } = this.state;

    return (
      <div>
        <div>
          <div className="border mb-2 px-2 py-2">
            <div className="mb-2 flex items-center gap-2 text-sm font-semibold">
              <div style={{ width: "92px" }}>Group Types: </div>

              {groupTypes.map((item) => {
                return (
                  <button
                    key={item}
                    type="button"
                    className={`rounded px-2 py-1 font-semibold ${
                      groupType === item
                        ? "bg-indigo-100 text-indigo-800"
                        : "text-gray-700 hover:bg-gray-200 hover:text-indigo-800"
                    }`}
                    onClick={() =>
                      this.handleFilterChanged({
                        type: "groupType",
                        value: item,
                      })
                    }
                  >
                    {item}
                  </button>
                );
              })}
            </div>
            <div className="mb-2 flex items-center gap-2 text-sm font-semibold">
              <div style={{ width: "92px" }}>Compare To: </div>
              {groupTypes.map((item) => {
                return (
                  <button
                    key={item}
                    type="button"
                    className={`rounded px-2 py-1 font-semibold ${
                      compareToGroupType === item
                        ? "bg-indigo-100 text-indigo-800"
                        : "text-gray-700 hover:bg-gray-200 hover:text-indigo-800"
                    }`}
                    onClick={() =>
                      this.handleFilterChanged({
                        type: "compareToGroupType",
                        value: item,
                      })
                    }
                  >
                    {item}
                  </button>
                );
              })}
            </div>
            <div className="border-t mt-1 flex items-center gap-2 pt-1 text-sm font-semibold">
              Layer:{" "}
              <div>
                {layerNums.map((item) => {
                  return (
                    <button
                      key={item}
                      type="button"
                      className={`rounded px-2 py-1 font-semibold ${
                        layerNum === item
                          ? "bg-indigo-100 text-indigo-800"
                          : "text-gray-700 hover:bg-gray-200 hover:text-indigo-800"
                      }`}
                      onClick={() =>
                        this.handleFilterChanged({
                          type: "layerNum",
                          value: item,
                        })
                      }
                    >
                      {item}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="border-t mt-1 flex items-center gap-2 pt-1 text-sm font-semibold">
              Metric:{" "}
              <div>
                {metrics.map((item) => {
                  return (
                    <button
                      key={item}
                      type="button"
                      className={`rounded px-2 py-1 font-semibold ${
                        metric === item
                          ? "bg-pink-100 text-pink-800"
                          : "text-gray-700 hover:bg-gray-200 hover:text-pink-800"
                      }`}
                      onClick={() =>
                        this.handleFilterChanged({
                          type: "metric",
                          value: item,
                        })
                      }
                    >
                      {item}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="border-t mt-1 flex items-center gap-2 pt-1 text-sm font-semibold">
              Demand Type Groups:{" "}
              <div>
                {demandTypes.map((item) => {
                  return (
                    <button
                      key={item}
                      type="button"
                      className={`rounded px-2 py-1 font-semibold ${
                        demandType === item
                          ? "bg-pink-100 text-pink-800"
                          : "text-gray-700 hover:bg-gray-200 hover:text-pink-800"
                      }`}
                      onClick={() =>
                        this.handleFilterChanged({
                          type: "demandType",
                          value: item,
                        })
                      }
                    >
                      {item}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div>
          {options && (
            <HighchartWrapper
              ref={this.ref1}
              options={options}
            ></HighchartWrapper>
          )}
        </div>
      </div>
    );
  }
}

// filter: layerNum, metric, groupType, compareToGroupType, isIncludeGhostImp
function _createSeriesData({ data, unitInfo, filter, timezone }) {
  const presetOptions =
    filter.demandType === "All" ? PRESET_OPTIONS : [filter.demandType];
  const seriesData = _.map(presetOptions, (preset, idx) => {
    let demandTypes = [];
    if (preset === PRESETS.GOOGLE_ELIGIBLE) {
      demandTypes = getGoogleEligibleDemandTypes();
    } else if (preset === PRESETS.NETWORK_BILLABLE) {
      demandTypes = unitInfo.billableDemandTypes;
    } else if (preset === PRESETS.PREBID) {
      demandTypes = getPrebidDemandTypes();
    } else if (preset === PRESETS.HOLISTIC) {
      demandTypes = getHolisticDemandTypes();
    }

    let finalData = [];
    let comData = [];
    const calculatedData = calculateReportsForDemandTypeCompare({
      reports: data.performance_report,
      aggregation: filter.aggregation,
      demandTypes,
      costCpm: unitInfo.costCpm,
      isIncludeGhostImp: filter.isIncludeGhostImp,
    });

    const groupedData = _.groupBy(calculatedData, "group_type");
    const compareData = groupedData[filter.compareToGroupType];

    const cIndex =
      filter.demandType === "All" ? idx : _.indexOf(PRESET_OPTIONS, preset);
    const color = Highcharts.getOptions().colors[cIndex];

    finalData = _.map(groupedData[filter.groupType], (d) => {
      const c = _.find(compareData, { _time: d._time });

      return {
        x:
          d._time * 1000 +
          moment.tz(d._time * 1000, timezone).utcOffset() * 60 * 1000,
        y: d[`_layer${filter.layerNum}_${filter.metric}`],
        gt: filter.groupType,
        compareTo: {
          y: c[`_layer${filter.layerNum}_${filter.metric}`],
          gt: filter.compareToGroupType,
        },
      };
    });

    comData = _.map(groupedData[filter.groupType], (d) => {
      const c = _.find(compareData, { _time: d._time });

      return {
        x:
          d._time * 1000 +
          moment.tz(d._time * 1000, timezone).utcOffset() * 60 * 1000,
        y: c[`_layer${filter.layerNum}_${filter.metric}`],
      };
    });

    return [
      {
        name: `(${filter.groupType}) ${preset}`,
        data: finalData,
        type: "spline",
        color,
      },
      {
        name: `(${filter.compareToGroupType}) ${preset}`,
        data: comData,
        type: "spline",
        dashStyle: "Dash",
        color: Highcharts.color(color).setOpacity(0.6).get(),
      },
    ];
  });

  return _.orderBy(_.flattenDeep(seriesData), ["type"], ["asc"]);
}

function _createChartOptions({ seriesData, timezone, filter }) {
  const { metric, layerNum } = filter;

  let min, max;
  if (metric === "str") {
    min = 0;
    max = 100;
  }

  let valueDecimalPoint = 2;
  if (metric === "req") valueDecimalPoint = 0;
  if (metric === "rrpm_per") valueDecimalPoint = 1;
  if (metric === "rrpm" || metric === "rrpm_net" || metric === "ecpm")
    valueDecimalPoint = 3;

  const chartTitle = "";
  const options = {
    title: {
      text: chartTitle,
    },
    time: {
      useUTC: true,
    },
    chart: {
      height: 260,
      backgroundColor: "rgba(0,0,0,0)",
      zoomType: "x",
    },
    tooltip: {
      shared: true,
      useHTML: true,
      backgroundColor: "rgba(255,255,255,1)", // use full white to make looking at all those numbers easier to read
      formatter() {
        return _tooltipFormatter({
          chart: this,
          timezone,
          isSortByYValue: true,
          // valuePrefix: metric === "cost" ? "$" : "",
          valuePostfix:
            metric === "str" || metric === "rrpm_per" || metric === "cost"
              ? "%"
              : "",
          valueDecimalPoint,
        });
      },
    },
    plotOptions: {
      spline: {
        marker: {
          enabled: false,
        },
      },
    },
    yAxis: [
      {
        title: {
          text: "",
        },
        min,
        max,
      },
    ],
    xAxis: {
      ...getDateTimeXAxis({ timezone }),
    },
    series: seriesData,
  };

  return options;
}

export function _tooltipFormatter({
  chart,
  timezone,
  isSortByYValue = false,
  valuePrefix = "",
  valuePostfix = "",
  valueDecimalPoint = 0,
}) {
  let sortedPoints = chart.points;
  if (isSortByYValue) {
    sortedPoints = chart.points
      .filter((p) => !p.series.options.dashStyle)
      .sort((pointA, pointB) => pointB.y - pointA.y);
  }

  return `
    <div style="text-align: center; font-size: 12px; margin-bottom: 2px;">
      ${moment
        .tz(
          chart.x - moment.tz(chart.x, timezone).utcOffset() * 60 * 1000,
          timezone,
        )
        .format("YYYY-MM-DD HH:mm Z")}
    </div>

    <div>
      <table style="margin: 0 auto;">
        <tbody>
          ${sortedPoints
            .map((point) => {
              const compareTo = point.point.compareTo;
              const diff = _.round(point.y - compareTo.y, valueDecimalPoint);
              const isWin = diff >= 0;
              return `
                <tr>
                  <td>
                    <span style="color: ${point.color};">\u25CF</span>
                  </td>
                  <td style="text-align: right; padding-right: 3px;">
                    ${point.series.name}:
                  </td>
                  
                  <td style="text-align: right; font-weight: 600;">
                    <span style="font-weight: ${isWin ? 600 : 400};">
                      (${point.point.gt}) 
                      <span style="font-weight: 400; color: 'light-gray';">${
                        point.point.prefix || valuePrefix
                      }</span>
                      ${Highcharts.numberFormat(point.y, valueDecimalPoint)} 
                        <span style="font-weight: 400; color: 'light-gray';">${
                          point.point.postfix || valuePostfix
                        }</span>
                      </span>
                    </span>
                  </td>
                  <td style="text-align: center; font-weight: 500; color: 'gray'; padding-left: 2px; padding-right: 2px;">
                    vs 
                  </td>
                  <td style="text-align: right; font-weight: 600;">
                    <span style="font-weight: ${!isWin ? 600 : 400};">
                      (${compareTo.gt}) 
                      <span style="font-weight: 400; color: 'light-gray';">${
                        point.point.prefix || valuePrefix
                      }</span>
                      ${Highcharts.numberFormat(compareTo.y, valueDecimalPoint)}
                      <span style="font-weight: 400; color: 'light-gray';">${
                        point.point.postfix || valuePostfix
                      }</span>
                    </span>
                  </td>
                  <td style="text-align: right; font-weight: 400;">
                    <span style="color: ${isWin ? "green" : "red"}">
                      (${isWin ? "+" : ""}${diff})
                    </span>
                  </td>
                </tr>
              `;
            })
            .join("")}
        </tbody>
      </table>
    </div>
  `;
}

export default DemandTypeCompareChart;
